import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-301b513a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-files" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "lp-files__info" }
const _hoisted_4 = { key: 0 }

import HcIcon from '@/modern/components/ui/HcIcon.vue';
import type { IAttachmentItem } from './labs';


export default /*#__PURE__*/_defineComponent({
  props: {
    items: null
  },
  setup(__props: any) {



const ICONS = { pdf: 'file', link: 'link', video: 'video', file: 'file' };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
      return (_openBlock(), _createElementBlock("a", {
        key: `${item.url}-${i}`,
        href: item.url,
        target: "_blank",
        rel: "noopener",
        class: "lp-files__item"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["lp-files__icon", `lp-files__icon--${item.kind}`])
        }, [
          _createVNode(HcIcon, {
            name: ICONS[item.kind],
            size: 20
          }, null, 8, ["name"])
        ], 2),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(item.name), 1),
          (item.description)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.description), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(HcIcon, {
          name: item.kind === 'link' || item.kind === 'video' ? 'external' : 'download',
          size: 16,
          class: "lp-files__action"
        }, null, 8, ["name"])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})